import React from 'react'
import PropTypes from 'prop-types'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import { Link } from 'react-router-dom'
import { FormattedHTMLMessage } from 'react-intl'
import FormattedMessage from '../../FormattedMessage/FormattedMessage'

const ProofOfPurchaseErrorModal = ({ isOpen, toggle }) => {
  // Generate unique IDs for accessibility
  const modalId = 'proof-purchase-error-modal'
  const modalTitleId = 'proof-purchase-error-title'

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size="lg"
      centered
      id={modalId}
      aria-labelledby={modalTitleId}
      role="dialog"
    >
      <ModalHeader toggle={toggle}>
        <span className="sr-only">
          <FormattedMessage id="global.label.close" defaultMessage="Close" />
        </span>
      </ModalHeader>
      <ModalBody>
        <h2 id={modalTitleId} className="text-center">
          <FormattedMessage id="error.coupon.proofOfPurchaseTitle" />
        </h2>
        <div className="error-message">
          <FormattedHTMLMessage id="error.coupon.proofOfPurchaseMessage" />
        </div>
      </ModalBody>
      <ModalFooter>
        <div className="w-100">
          <div className="row">
            <div className="col">
              <Link className="redirect w-100" to="/support" aria-label="Go to support page">
                <Button block outline color="danger" onClick={toggle} aria-hidden="true">
                  <FormattedMessage id="global.label.popoverClose" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </ModalFooter>
    </Modal>
  )
}

ProofOfPurchaseErrorModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
}

export default ProofOfPurchaseErrorModal
